module.exports = __webpack_public_path__ + "img/nullSmImg.66a40428.png";